import { supabase } from "@/services/supabase/client";
import { Database } from "@/services/supabase/types";

export type SubscriptionType = "FREE" | "PAID" | null;
export type SubscriptionStatus = "active" | "inactive" | "trialing" | null;

type DbSubscriptions = Database["public"]["Tables"]["subscriptions"];
export interface SubscriptionRow extends Omit<DbSubscriptions["Row"], "type" | "status"> {
  type: SubscriptionType;
  status: SubscriptionStatus;
}
export interface SubscriptionInsert extends Omit<DbSubscriptions["Insert"], "type" | "status"> {
  type?: SubscriptionType;
  status: SubscriptionStatus;
}
export interface SubscriptionUpdate extends Omit<DbSubscriptions["Update"], "type" | "status"> {
  type: SubscriptionType;
  status: SubscriptionStatus;
}

async function fetchSubscription(userId: string): Promise<SubscriptionRow | null> {
  const { data, error } = await supabase.from("subscriptions").select("*").eq("user_id", userId).maybeSingle();

  if (error) {
    throw error;
  }

  return data as SubscriptionRow;
}

async function createStripeCustomer(): Promise<{ message: string }> {
  const { data, error } = await supabase.functions.invoke("subscription", {
    body: { operation: "create_customer" },
  });

  if (error) throw error;

  return data;
}

async function createStripeSubscription(priceId: string): Promise<{ message: string; clientSecret: string }> {
  const { data, error } = await supabase.functions.invoke("subscription", {
    body: { operation: "create_subscription", price_id: priceId },
  });

  if (error) throw error;
  return data;
}

async function createStripeTrialSubscription(priceId: string): Promise<{ message: string }> {
  const { data, error } = await supabase.functions.invoke("subscription", {
    body: { operation: "create_trial_subscription", price_id: priceId },
  });

  if (error) throw error;
  return data;
}

async function cancelSubscription(): Promise<{ message: string }> {
  const { data, error } = await supabase.functions.invoke("subscription", {
    body: { operation: "cancel_subscription" },
  });

  if (error) throw error;

  return data;
}

async function resumeSubscription(): Promise<{ message: string }> {
  const { data, error } = await supabase.functions.invoke("subscription", {
    body: { operation: "resume_subscription" },
  });

  if (error) throw error;

  return data;
}

export const stripeFetchers = {
  cancelSubscription,
  createStripeCustomer,
  createStripeSubscription,
  createStripeTrialSubscription,
  fetchSubscription,
  resumeSubscription,
};
